import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { OpsSwitchComponent } from "src/app/b2b/ops/watchlist/components/switch/switch.component";
import { Button } from "primeng/button";
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
} from "primeng/dynamicdialog";

@Component({
  selector: "v-cookie-dialog",
  templateUrl: "./cookie-dialog.component.html",
  styleUrls: ["./cookie-dialog.component.scss"],
  imports: [CommonModule, FormsModule, OpsSwitchComponent, Button, DynamicDialogModule],
  providers: [DialogService],
})
export class CookieDialogComponent {
  public showPolicy: boolean;
  public isPerformanceCookie: boolean;

  public constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    this.showPolicy = false;
    this.isPerformanceCookie = true;
    this.showPolicy = this.config.data?.showPolicy;
  }
}
